import { render, staticRenderFns } from "./ContentIcon.vue?vue&type=template&id=494637fd&scoped=true&"
import script from "./ContentIcon.vue?vue&type=script&lang=js&"
export * from "./ContentIcon.vue?vue&type=script&lang=js&"
import style0 from "./ContentIcon.vue?vue&type=style&index=0&id=494637fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494637fd",
  null
  
)

export default component.exports